/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tc_CopyInputs */

const en_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Copy`)
};

const fr_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copie de TC`)
};

const de_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC-Kopie`)
};

const it_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia TC`)
};

const ru_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Copy`)
};

const es_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia de TC`)
};

const zh_cn2_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC副本`)
};

const ja_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TCコピー`)
};

const hi_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीसी कॉपी`)
};

const pt_pt2_tc_copy = /** @type {(inputs: Tc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia TC`)
};

/**
* | output |
* | --- |
* | "TC Copy" |
*
* @param {Tc_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tc_copy = /** @type {((inputs?: Tc_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tc_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tc_copy(inputs)
	if (locale === "de") return de_tc_copy(inputs)
	if (locale === "it") return it_tc_copy(inputs)
	if (locale === "ru") return ru_tc_copy(inputs)
	if (locale === "es") return es_tc_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_tc_copy(inputs)
	if (locale === "ja") return ja_tc_copy(inputs)
	if (locale === "hi") return hi_tc_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_tc_copy(inputs)
	return en_tc_copy(inputs)
});